import styled from "styled-components";

export const BookingConfirmationBlock = styled.div`
  margin-bottom: ${({ theme }) => theme.type.sizes.size12};

  * {
    line-height: 1.8;
  }
`;